import React from 'react';
import { THEMES } from './data';

// Abstract per-theme glyphs: a node network (agents) and a grid circuit (infrastructure).
const Glyph = ({ n }) => n === '01' ? (
  <svg viewBox="0 0 120 120" className="w-16 h-16 sm:w-24 sm:h-24 shrink-0" aria-hidden="true">
    <g stroke="#111" strokeWidth="3" fill="none"><path d="M20 30 L60 60 L100 25 M60 60 L30 95 M60 60 L95 90" /></g>
    {[[20, 30], [100, 25], [30, 95], [95, 90]].map(([x, y]) => <rect key={x} x={x - 7} y={y - 7} width="14" height="14" fill="#111" />)}
    <rect x="48" y="48" width="24" height="24" transform="rotate(45 60 60)" fill="#365CFF" stroke="#111" strokeWidth="3" />
  </svg>
) : (
  <svg viewBox="0 0 120 120" className="w-16 h-16 sm:w-24 sm:h-24 shrink-0" aria-hidden="true">
    <g stroke="#F5F3EB" strokeWidth="3" fill="none"><rect x="14" y="14" width="92" height="92" /><path d="M14 52 H106 M52 14 V106 M80 52 V106 M14 80 H52" /></g>
    <circle cx="80" cy="80" r="12" fill="#D7FF38" stroke="#F5F3EB" strokeWidth="3" />
  </svg>
);

const ThemeCard = ({ t, dark }) => (
  <article className={`relative min-w-0 border-2 border-[#111] p-6 sm:p-10 cv-lift ${dark ? 'bg-[#111] text-[#F5F3EB] shadow-[8px_8px_0_#FF6338]' : 'bg-[#D7FF38] shadow-[8px_8px_0_#111]'}`} data-testid={`theme-card-${t.n}`}>
    <div className="flex items-start justify-between gap-4">
      <span className={`cv-display font-extrabold leading-none text-[80px] sm:text-[150px] ${dark ? 'text-[#FF6338]' : 'text-[#111]'}`}>{t.n}</span>
      <Glyph n={t.n} />
    </div>
    <p className="text-[11px] font-bold uppercase tracking-[0.25em] mt-2">Theme {t.n}</p>
    <h3 className="cv-display text-xl sm:text-3xl xl:text-[2rem] font-extrabold uppercase leading-[1.05] mt-2 break-words [overflow-wrap:anywhere]">{t.title}</h3>
    <p className={`mt-5 text-sm sm:text-base font-medium ${dark ? 'text-[#F5F3EB]/85' : ''}`}>{t.blurb}</p>
    <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.2em]">Suggested problem areas</p>
    <ul className="mt-3 flex flex-wrap gap-2">
      {t.areas.map((a) => (
        <li key={a} className={`max-w-full break-words border-2 px-2.5 py-1 text-xs font-bold ${dark ? 'border-[#F5F3EB]/60' : 'border-[#111] bg-[#F5F3EB]'}`}>{a.replace(/\.$/, '')}</li>
      ))}
    </ul>
  </article>
);

export const ConvergeThemes = () => (
  <section id="themes" className="scroll-mt-20 border-b-2 border-[#111]" data-testid="themes-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em]">[ 03 ] Hackathon themes</p>
          <h2 className="cv-display font-extrabold uppercase leading-[0.9] mt-3 text-5xl sm:text-7xl">Two themes.<br /><span className="text-[#365CFF]">Pick your arena.</span></h2>
        </div>
      </div>
      <div className="mt-12 grid lg:grid-cols-2 gap-8">
        {THEMES.map((t, i) => <ThemeCard key={t.n} t={t} dark={i === 1} />)}
      </div>
    </div>
  </section>
);
